'use client';
import { useState } from 'react';
import { useApiStore } from '@/context/global/stores/apiStore';

export function useGetOAuth() {
  const { API } = useApiStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchOAuthUrl = async (): Promise<string | null> => {
    setLoading(true);
    setError(null);

    try {
      const response = await API.Auth.GetOAuth();
      return response.data.responseObject.link;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to get OAuth URL';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchOAuthUrl,
    loading,
    error,
  };
}
